document.addEventListener("DOMContentLoaded", () => {
  /* PARTICLES */
  function spawnParticles(id, count) {
    const el = document.getElementById(id);
    if (!el) return;
    el.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const s = document.createElement("span");
      const size = Math.random() * 4 + 2;
      const delay = Math.random() * 12;
      const x = Math.random() * 100;
      const startY = Math.random() * -180;
      s.style.width = size + "px";
      s.style.height = size + "px";
      s.style.left = x + "%";
      s.style.bottom = startY + "px";
      s.style.animationDelay = delay + "s";
      el.appendChild(s);
    }
  }

  spawnParticles("hero-particles", 35);
  spawnParticles("about-particles", 28);
  spawnParticles("box-particles", 20);
  spawnParticles("news-particles", 25);
  spawnParticles("products-particles", 30);
  spawnParticles("legal-particles", 28);

  /* PROMOTIONAL BANNER ROTATION */
  const promoBanner = document.getElementById("promo-banner-track");
  if (promoBanner) {
    const messages = promoBanner.querySelectorAll(".ht-promo-message");
    let currentMessageIndex = 0;

    function showPromoMessage(index) {
      messages.forEach((msg, i) => {
        msg.classList.remove("active", "exit");
        if (i === index) {
          msg.classList.add("active");
        }
      });
    }

    function rotatePromoMessages() {
      const currentMsg = messages[currentMessageIndex];
      currentMsg.classList.add("exit");

      setTimeout(() => {
        currentMsg.classList.remove("active", "exit");
        currentMessageIndex = (currentMessageIndex + 1) % messages.length;
        showPromoMessage(currentMessageIndex);
      }, 600);
    }

    // Show first message immediately
    showPromoMessage(0);

    // Rotate messages every 4 seconds
    setInterval(rotatePromoMessages, 4000);
  }

  /* FEATURED PRODUCTS CAROUSEL */
  let currentSlideIndex = 0;
  let featuredProductsData = [];
  const PRODUCTS_PER_SLIDE = 5;

  async function loadFeaturedProducts() {
    const container = document.getElementById("js-featured-products");
    if (!container) return;

    try {
      const response = await fetch("/products.json?limit=250");
      const data = await response.json();

      featuredProductsData = data.products.filter((product) =>
        product.tags.some((tag) => tag.toLowerCase() === "featured")
      );

      if (featuredProductsData.length === 0) {
        container.innerHTML = `
          <div class="ht-no-products">
            <div class="ht-no-products__icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
              </svg>
            </div>
            <h3>No Featured Products Available</h3>
            <p>Products with the "Featured" tag will appear here.</p>
            <div class="ht-no-products__actions">
              <a href="/collections/all" class="ht-btn ht-btn--primary">Browse All Products</a>
            </div>
          </div>
        `;
        return;
      }

      renderCarousel();
      initCarouselControls();
    } catch (error) {
      console.error("❌ Error loading featured products:", error);
      container.innerHTML = `
        <div class="ht-no-products">
          <h3 style="color: #ff6666;">Error Loading Products</h3>
          <p>Please refresh the page or try again later.</p>
        </div>
      `;
    }
  }

  function renderCarousel() {
    const container = document.getElementById("js-featured-products");
    const totalSlides = Math.ceil(
      featuredProductsData.length / PRODUCTS_PER_SLIDE
    );

    const carouselHTML = `
      <button class="ht-carousel-arrow ht-carousel-arrow--prev" id="carousel-prev" aria-label="Previous products">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        </svg>
      </button>

      <div class="ht-carousel-track-container">
        <div class="ht-carousel-track" id="carousel-track">
          ${renderAllProducts()}
        </div>
      </div>

      <button class="ht-carousel-arrow ht-carousel-arrow--next" id="carousel-next" aria-label="Next products">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </button>

      <div class="ht-carousel-indicators" id="carousel-indicators">
        ${Array.from(
          { length: totalSlides },
          (_, i) => `
          <button class="ht-carousel-indicator ${
            i === 0 ? "active" : ""
          }" data-slide="${i}" aria-label="Go to slide ${i + 1}"></button>
        `
        ).join("")}
      </div>
    `;

    container.innerHTML = carouselHTML;
  }

  function renderAllProducts() {
    return featuredProductsData
      .map((product) => renderProductCard(product))
      .join("");
  }

  function renderProductCard(product) {
    const variant = product.variants[0];

    const priceStr = String(variant.price);
    const price = priceStr.includes(".")
      ? parseFloat(priceStr)
      : parseFloat(priceStr) / 100;

    const comparePrice = variant.compare_at_price
      ? String(variant.compare_at_price).includes(".")
        ? parseFloat(variant.compare_at_price)
        : parseFloat(variant.compare_at_price) / 100
      : null;

    const onSale = comparePrice && comparePrice > price;
    const available = variant.available;
    const imageUrl = product.images[0]
      ? product.images[0].src
      : "https://via.placeholder.com/400x400?text=No+Image";

    return `
      <div class="ht-featured-product">
        ${onSale ? '<span class="ht-product-badge">Sale</span>' : ""}
        
        <a href="/products/${
          product.handle
        }" class="ht-featured-product__image">
          <img src="${imageUrl}" 
               alt="${product.title}" 
               loading="lazy"
               width="400"
               height="400">
        </a>
        
        <div class="ht-featured-product__body">
          <h5 class="ht-featured-product__title">
            <a href="/products/${product.handle}">${product.title}</a>
          </h5>
          <div class="ht-featured-product__price">
            ${
              onSale
                ? `
              <span class="ht-price-sale">£${price.toFixed(2)}</span>
              <span class="ht-price-compare">£${comparePrice.toFixed(2)}</span>
            `
                : `<span class="ht-price">£${price.toFixed(2)}</span>`
            }
          </div>
        </div>
        
        <div class="ht-featured-product__footer">
          ${
            available
              ? `
            <form class="ht-quick-add-form" data-product-id="${product.id}">
              <input type="hidden" name="id" value="${variant.id}">
              <button type="submit" class="ht-btn-add-cart">
                <span class="btn-icon">🛒</span>
                <span class="btn-text">Add to Cart</span>
              </button>
            </form>
          `
              : '<span class="ht-badge-soldout">Sold Out</span>'
          }
        </div>
      </div>
    `;
  }

  function initCarouselControls() {
    const prevBtn = document.getElementById("carousel-prev");
    const nextBtn = document.getElementById("carousel-next");
    const indicators = document.querySelectorAll(".ht-carousel-indicator");
    const track = document.getElementById("carousel-track");
    const trackContainer = track.parentElement;

    const totalSlides = Math.ceil(
      featuredProductsData.length / PRODUCTS_PER_SLIDE
    );

    function updateCarousel() {
      // Calculate the exact pixel offset based on product width + gap
      const firstProduct = track.querySelector(".ht-featured-product");
      if (!firstProduct) return;

      const productWidth = firstProduct.offsetWidth;
      const gap = 40; // gap between products (updated to 40px for better spacing)
      const slideWidth = (productWidth + gap) * PRODUCTS_PER_SLIDE;
      const offset = currentSlideIndex * slideWidth;

      track.style.transform = `translateX(-${offset}px)`;

      // Update indicators
      indicators.forEach((indicator, index) => {
        indicator.classList.toggle("active", index === currentSlideIndex);
      });

      // Update button states
      prevBtn.disabled = currentSlideIndex === 0;
      nextBtn.disabled = currentSlideIndex === totalSlides - 1;
    }

    prevBtn.addEventListener("click", () => {
      if (currentSlideIndex > 0) {
        currentSlideIndex--;
        updateCarousel();
      }
    });

    nextBtn.addEventListener("click", () => {
      if (currentSlideIndex < totalSlides - 1) {
        currentSlideIndex++;
        updateCarousel();
      }
    });

    indicators.forEach((indicator) => {
      indicator.addEventListener("click", (e) => {
        currentSlideIndex = parseInt(e.target.dataset.slide);
        updateCarousel();
      });
    });

    // Initial update after DOM has rendered
    setTimeout(updateCarousel, 0);
  }

  // Load featured products on page load
  loadFeaturedProducts();

  /* ADD TO CART (delegated) */
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form.classList.contains("ht-quick-add-form")) return;
    e.preventDefault();

    const btn = form.querySelector("button[type='submit']");
    if (!btn) return;

    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: form.querySelector("input[name='id']").value,
        quantity: 1,
      }),
    })
      .then((r) => r.json())
      .then(() => {
        btn.innerHTML = "Added ✓";
        btn.style.background = "#2ecc71";
        document.dispatchEvent(new CustomEvent("cart:updated"));
        setTimeout(() => {
          btn.innerHTML = original;
          btn.disabled = false;
          btn.style.background = "";
        }, 1800);
      })
      .catch(() => {
        btn.innerHTML = "Error";
        btn.style.background = "#e74c3c";
        setTimeout(() => {
          btn.innerHTML = original;
          btn.disabled = false;
          btn.style.background = "";
        }, 1800);
      });
  });

  /* CART COUNT REFRESH */
  function refreshCartCount() {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        const cc = document.getElementById("cart-count");
        if (cc) {
          cc.textContent = cart.item_count;
          cc.style.display = cart.item_count > 0 ? "flex" : "none";
        }
      });
  }
  refreshCartCount();
  document.addEventListener("cart:updated", refreshCartCount);

  /* SPLIT HERO CAROUSEL */
  const heroCarousel = document.getElementById("ht-featured-carousel");
  if (heroCarousel) {
    const items = heroCarousel.querySelectorAll(".ht-carousel-item");
    const indicators = heroCarousel.querySelectorAll(
      ".ht-carousel-indicators button"
    );
    let currentSlide = 0;

    function showSlide(index) {
      items.forEach((item, i) => {
        item.classList.toggle("active", i === index);
      });
      indicators.forEach((indicator, i) => {
        indicator.classList.toggle("active", i === index);
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % items.length;
      showSlide(currentSlide);
    }

    setInterval(nextSlide, 5000);

    indicators.forEach((indicator, i) => {
      indicator.addEventListener("click", () => {
        currentSlide = i;
        showSlide(currentSlide);
      });
    });
  }

  /* SPLIT NEWSLETTER FORM */
  const splitNlForm = document.getElementById("newsletter-signup-form-split");
  if (splitNlForm) {
    splitNlForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const email = document.getElementById("newsletter-email-split");
      const result = document.getElementById("newsletter-result-split");
      const submitBtn = splitNlForm.querySelector(".ht-newsletter-submit-btn");
      const btnText = submitBtn.querySelector(".ht-btn-text");
      const btnLoading = submitBtn.querySelector(".ht-btn-loading");

      const valid =
        email && /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email.value.trim());

      if (!valid) {
        result.textContent = "Please enter a valid email address.";
        result.className = "ht-newsletter-result error";
        return;
      }

      btnText.style.display = "none";
      btnLoading.style.display = "inline";
      submitBtn.disabled = true;

      setTimeout(() => {
        result.textContent =
          "Successfully subscribed! Welcome to the HighTide community.";
        result.className = "ht-newsletter-result success";
        splitNlForm.reset();

        btnText.style.display = "inline";
        btnLoading.style.display = "none";
        submitBtn.disabled = false;

        setTimeout(() => {
          result.style.display = "none";
          setTimeout(() => {
            result.className = "ht-newsletter-result";
            result.style.display = "";
          }, 300);
        }, 4000);
      }, 1200);
    });
  }
});
